import Cookies from 'js-cookie';
import { scrollToFirstError } from '../validation';
import { url } from '../../base-path';

/**
 * Ankieta Testera Maślanki Mrągowskiej — modal nad modalem gry.
 *
 * Pokazuje się DELAY_MS po wejściu na ekran `thanks` modala gry (armQuestionnaire() woła
 * showThanks() w application-modal.js) i tylko wtedy, gdy uczestnik nie ma jeszcze ciasteczka.
 * Pytania i odpowiedzi renderuje Twig z App\Entity\Questionnaire::QUESTIONS — ta sama stała
 * waliduje POST po stronie serwera, więc wartości radiobuttonów muszą się zgadzać co do znaku.
 */

const MODAL_SELECTOR = '#modal-questionnaire';
const GAME_MODAL_SELECTOR = '#modal-form-application';

const COOKIE = 'questionnaire_done';
// Wysłana ankieta = koniec tematu (praktycznie bezterminowo). Zamknięcie krzyżykiem to tylko
// „nie teraz" — po dwóch dniach można spróbować ponownie.
const SUBMITTED_DAYS = 3650;
const DISMISSED_DAYS = 2;

const DELAY_MS = 2500;

let _uuid = null;
let _timer = null;

const $modal = () => $(MODAL_SELECTOR);
const isDone = () => Boolean(Cookies.get(COOKIE));
const markDone = (days) => Cookies.set(COOKIE, '1', { expires: days, path: '/' });

/**
 * Uzbrój pokazanie ankiety. Wywoływane przy wejściu na `thanks`; nic nie robi, jeśli uczestnik
 * już ankietę wypełnił (albo świeżo ją zamknął).
 */
export function armQuestionnaire(uuid) {
    clearQuestionnaire();

    if (isDone()) {
        return;
    }

    _uuid = uuid;
    _timer = setTimeout(function () {
        _timer = null;
        // Ciasteczko mogło pojawić się w innej karcie w trakcie odliczania.
        if (isDone()) {
            return;
        }
        resetForm();
        $modal().modal('show');
    }, DELAY_MS);
}

/** Skasuj odliczanie — modal gry został zamknięty, zanim ankieta się pokazała. */
export function clearQuestionnaire() {
    if (_timer) {
        clearTimeout(_timer);
        _timer = null;
    }
    _uuid = null;
}

function resetForm() {
    const $form = $modal().find('.questionnaire-form');
    $form[0]?.reset();
    $modal().find('.questionnaire-question').removeClass('is-invalid');
    $modal().find('.questionnaire-error').text('');
    $modal().find('.questionnaire-submit').prop('disabled', false);

    // Cofnij ekran podziękowania — modal jest w DOM na stałe, więc bez tego ponowne otwarcie
    // (np. po skasowaniu ciasteczka) pokazałoby podziękowanie zamiast pytań.
    $modal().find('.questionnaire-header, .questionnaire-form').removeClass('d-none');
    $modal().find('.questionnaire-thanks').addClass('d-none');
}

/**
 * Ankieta wysłana — zamiast zamykać modal, podmieniamy jego treść na podziękowanie.
 * Modal zostaje otwarty; uczestnik zamyka go krzyżykiem (ciasteczko jest już zapisane, więc
 * handler hidden.bs.modal nie nadpisze go krótkim „nie teraz").
 */
function showThanks() {
    $modal().find('.questionnaire-header, .questionnaire-form').addClass('d-none');
    $modal().find('.questionnaire-thanks').removeClass('d-none');
}

/**
 * Wszystkie pytania są obowiązkowe. Zwraca true, jeśli komplet odpowiedzi jest zaznaczony;
 * w przeciwnym razie oznacza braki i przewija do pierwszego z nich.
 */
function validate(form) {
    let valid = true;

    $(form).find('.questionnaire-question').each(function () {
        const $question = $(this);
        const answered = $question.find('input[type="radio"]:checked').length > 0;

        $question.toggleClass('is-invalid', !answered);
        $question.find('.questionnaire-error').text(answered ? '' : 'Wybierz odpowiedź');

        valid = valid && answered;
    });

    if (!valid) {
        scrollToFirstError(form);
    }

    return valid;
}

/** Błędy z serwera (422) trafiają pod właściwe pytania — klucze to q1…q6. */
function showFormErrors(form, formErrors) {
    Object.entries(formErrors).forEach(function ([field, messages]) {
        $(form)
            .find(`.questionnaire-question[data-question="${field}"]`)
            .addClass('is-invalid')
            .find('.questionnaire-error')
            .text(messages?.[0] || 'Wybierz odpowiedź');
    });

    scrollToFirstError(form);
}

$(document).on('submit', `${MODAL_SELECTOR} .questionnaire-form`, function (event) {
    event.preventDefault();

    const form = this;
    const $button = $(form).find('.questionnaire-submit');

    if (!validate(form)) {
        return;
    }

    $button.prop('disabled', true);

    $.ajax({
        type: 'POST',
        url: url(`/api/application/${_uuid}/questionnaire`),
        // Ten sam token co reszta akcji modala gry — renderowany na #modal-form-application.
        data: `${$(form).serialize()}&_token=${encodeURIComponent($(GAME_MODAL_SELECTOR).data('game-csrf'))}`,
    }).done(function () {
        // Ciasteczko PRZED podmianą treści — handler hidden.bs.modal poniżej rozpoznaje po jego
        // braku, że modal zamknięto krzyżykiem, a nie wysyłką.
        markDone(SUBMITTED_DAYS);
        showThanks();
    }).fail(function (xhr) {
        // 409 = to zgłoszenie ma już ankietę (nieświeża karta albo dubel, który wyprzedził
        // zablokowany przycisk). Nie ma sensu pokazywać formularza jeszcze raz.
        if (xhr.status === 409) {
            markDone(SUBMITTED_DAYS);
            showThanks();
            return;
        }

        if (xhr.responseJSON?.formErrors) {
            showFormErrors(form, xhr.responseJSON.formErrors);
        } else {
            alert(xhr.responseJSON?.errors?.[0] || 'Nie udało się zapisać ankiety. Spróbuj ponownie.');
        }

        $button.prop('disabled', false);
    });
});

// Zamknięcie krzyżykiem/ESC bez wysyłki — ciasteczka jeszcze nie ma, więc zapisujemy krótkie.
// Po wysyłce warunek jest już nieprawdziwy (długie ciasteczko poszło przed .modal('hide')).
$(document).on('hidden.bs.modal', MODAL_SELECTOR, function () {
    if (!isDone()) {
        markDone(DISMISSED_DAYS);
    }
});
